import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { DataSourceListActions } from './data-source-list.store';
import { ViewsDataService } from '../../services/views-data.service';

@Injectable({ providedIn: 'root' })
export class DataSourceListEffects {
  private readonly actions$ = inject(Actions);
  private readonly viewsHttpService = inject(ViewsDataService);

  public effect = createEffectFactory(DataSourceListActions, this.actions$);

  public createOne$ = this.effect(DataSourceListActions.fetch, () =>
    this.viewsHttpService.listDataSources(),
  );
}
